import axios, {CancelTokenSource} from 'axios';
import Services from '../Services';
import ServiceRequest from '../ServiceRequest';

export const getApplicationListData = async (): Promise<any> => {
  const url = `/applications-list/all`;
  return ServiceRequest.get(url);
};

export const createNewApplication = async (data: any): Promise<any> => {
  const url = `/add-application`;

  return ServiceRequest.post(url, {payload: data});
};

export const createNewPad = async (data: any): Promise<any> => {
  const url = `/add-pad`;

  return ServiceRequest.post(url, {payload: data});
};

export const getPadsData = async (application_id: number): Promise<any> => {
  const url = `/pads/${application_id}`;
  return ServiceRequest.get(url);
};

export const getModuleListData = async (
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/list/all`;
  return ServiceRequest.get(url);
};

export const getSubmoduleDropDownList = async (
  application_name: string,
  module_name: string,
  global_search: string
): Promise<any> => {
  const url = `/${application_name}/${module_name}/search/${global_search}/submodules`;
  return ServiceRequest.get(url);
};

export const getLocalSearchResults = async (
  application_name: string,
  module_name: string,
  global_search: string,
  data: any
): Promise<any> => {
  const url = `/${application_name}/${module_name}/search/${global_search}/search_results`;
  return ServiceRequest.post(url, {payload: data});
};

export const getDocumentSearchResults = async (
  application_name: string,
  module_name: string,
  global_search: string,
  data: any
): Promise<any> => {
  const url = `/${application_name}/${module_name}/search/${global_search}/document_search`;
  return ServiceRequest.post(url, {payload: data});
};

export const getGlobalAISearch = async (
  application_name: string,
  module_name: string,
  data: any
): Promise<any> => {
  const url = `/${application_name}/${module_name}/global/search`;
  return ServiceRequest.post(url, {payload: data});
};

export const getUserAuditsData = async (data: any): Promise<any> => {
  const url = `/user/audit_logs`;
  return ServiceRequest.post(url, {payload: data});
};

export const getUserAccessAuditsData = async (data: any): Promise<any> => {
  const url = `/user-access/audit_logs`;
  return ServiceRequest.post(url, {payload: data});
};

export const addNewExternalAuditData = async (data: any): Promise<any> => {
  const url = `/external_audit/add_new`;
  return ServiceRequest.post(url, {payload: data});
};

export const addNewExternalAuditFile = async (data: any): Promise<any> => {
  const url = `/external_audit/upload_file_data`;
  return ServiceRequest.post(url, {payload: data});
};

export const addNewUserData = async (
  data: any,
  application_name: any
): Promise<any> => {
  const url = `/${application_name}/users/add_new`;
  return ServiceRequest.post(url, {payload: data});
};
export const addNewLMSUserData = async (
  data: any,
  application_name: any
): Promise<any> => {
  const url = `/${application_name}/users/lms_add_new`;
  return ServiceRequest.post(url, {payload: data});
};
export const getSearchForm = async (
  application_name: string,
  module_name: string,
  menu_item?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/${application_name}/${module_name}/search-form?menu_item=${
    menu_item || ''
  }`;
  return ServiceRequest.get(url, {payload: cancelToken});
};
export const getCmsData = async (
  application_name: string,
  module_name: string,
  data: any,
  user_id?: string,
  operation_value?: string,
  uploaded_data?: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/cms?user_id=${user_id}&operation_value=${operation_value}`;

  return ServiceRequest.post(url, {payload: data}, cancelToken);
};
export const postCourseData = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string,
  user_id?: string,
  uploaded_data?: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/course_management?user_id=${user_id}&operation_value=${operation_value}`;

  return ServiceRequest.post(url, {payload: data}, cancelToken);
};
export const postUploadData = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string,
  onUploadProgress?: (progressEvent: any) => void
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/UploadData?operation_value=${operation_value}`;
  return ServiceRequest.postDoc(url, {payload: data}, 0, onUploadProgress);
};
export const fileCabinetUploadData = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string,
  onUploadProgress?: (progressEvent: any) => void
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/UploadFiles?operation_value=${operation_value}`;
  return ServiceRequest.postDoc(url, {payload: data}, 0, onUploadProgress);
};
export const saveFileCabinetDocumentData = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/UploadFilesMetadata?operation_value=${operation_value}`;
  return ServiceRequest.post(url, {payload: data});
};
export const deleteFileCabinetDocumentData = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/fileDelete?operation_value=${operation_value}`;
  return ServiceRequest.post(url, {payload: data});
};
export const createFileFolder = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/createFolderfile?operation_value=${operation_value}`;
  return ServiceRequest.post(url, {payload: data});
};
export const permissionsCheck = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/permissions?operation_value=${operation_value}`;
  return ServiceRequest.post(url, {payload: data});
};
export const editFileFolder = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/editFileFolder?operation_value=${operation_value}`;
  return ServiceRequest.post(url, {payload: data});
};
export const getUploadData = async (
  application_name: string,
  module_name: string,
  data: any,
  operation_value?: string,
  onDownloadProgress?: (progressEvent: any) => void
): Promise<any> => {
  const url = `data/${application_name}/${module_name}/UploadData?operation_value=${operation_value}`;
  return ServiceRequest.getDocPPt(url, {payload: data}, 0, onDownloadProgress);
};
export const DownloadUploadData = async (data: any): Promise<any> => {
  const url = `data/download?operation_value=${data}`;
  return ServiceRequest.getDoc(url);
};
export const getSearchResultsData = async (
  application_name: string,
  module_name: string,
  data: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/data/${application_name}/${module_name}/search-form`;

  return ServiceRequest.post(url, {payload: data}, cancelToken);
};
export const getLMSResultsData = async (
  application_name: string,
  module_name: string,
  data: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/data/${application_name}/${module_name}/lms-form`;

  return ServiceRequest.post(url, {payload: data}, cancelToken);
};
export const getLMSFileData = async (
  data: any,
  cancelToken: CancelTokenSource
): Promise<any> => {
  const url = `data/lms`;
  return ServiceRequest.post(url, {payload: data}, cancelToken);
};
export const getIsBHStatus = async (
  application_name: string,
  module_name: string,
  data: any
): Promise<any> => {
  const url = `/${application_name}/${module_name}/check_isBH`;
  return ServiceRequest.post(url, {payload: data});
};

export const getSubModuleListData = async (
  application_name: string,
  module_name: string,
  module_list_item?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/${application_name}/${module_name}/submodule/list/all?module_list_item=${
    module_list_item || ''
  }`;
  return ServiceRequest.get(url, {payload: cancelToken});
};

export const getPageSection = async (
  application_name: string,
  module_name: string,
  submodule_name: string,
  module_list_item?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/${application_name}/${module_name}/submodule/${submodule_name}/page-section?module_list_item=${
    module_list_item || ''
  }`;
  return ServiceRequest.get(url, {payload: cancelToken});
};
export const getPageData = async (
  application_name: string,
  module_name: string,
  submodule_name: string,
  data: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/data/${application_name}/${module_name}/submodule/${submodule_name}/page-section`;
  return ServiceRequest.post(url, {payload: data, cancelToken});
};
export const getPeriodontalChartData = async (
  application_name: string,
  module_name: string,
  submodule_name: string,
  data: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/data/${application_name}/${module_name}/submodule/${submodule_name}/periodontal-chart`;
  return ServiceRequest.post(url, {payload: data, cancelToken});
};

export const getDocumentsHierarchyData = async (
  module_name: string,
  submodule_name: string,
  user_id: string,
  data: any,
  legacy_app?: any,
  unique_id?: string,
  menuItem?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `data/module/${module_name}/submodule/${submodule_name}/directories?user_id=${user_id}&legacy_app=${
    legacy_app || ''
  }&unique_id=${unique_id}&menu_item=${menuItem}`;
  return ServiceRequest.post(url, {payload: data, cancelToken});
};
export const getDocumentsSearchHierarchyData = async (
  module_name: string,
  submodule_name: string,
  user_id: string,
  data: any,
  legacy_app?: any,
  unique_id?: string,
  menuItem?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url =
    `data/module/${module_name}/submodule/${submodule_name}` +
    `/directories_search?user_id=${user_id}&legacy_app=${legacy_app || ''}` +
    `&unique_id=${unique_id}&menu_item=${menuItem}`;
  return ServiceRequest.post(url, {payload: data, cancelToken});
};
export const getDocumentsFilecabinetHierarchyData = async (
  module_name: string,
  submodule_name: string,
  user_id: string,
  data: any,
  legacy_app?: any,
  unique_id?: string,
  menuItem?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `data/module/${module_name}/submodule/${submodule_name}/filecabinet_directories?user_id=${user_id}&legacy_app=${
    legacy_app || ''
  }&unique_id=${unique_id}&menu_item=${menuItem}`;
  return ServiceRequest.post(url, {payload: data, cancelToken});
};
export const getFolderContents = async (
  module_name: string,
  submodule_name: string,
  parent_id: number | string,
  user_id: string,
  unique_id: string,
  data: any,
  legacy_app?: any,
  menuItem?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `data/module/${module_name}/submodule/${submodule_name}/directory_contents?parent_id=${parent_id}&user_id=${user_id}&legacy_app=${
    legacy_app || ''
  }&unique_id=${unique_id}&menu_item=${menuItem}`;
  return ServiceRequest.post(url, {payload: data}, cancelToken);
};

export const getFilesContent = async (
  module_name: string,
  submodule_name: string,
  user_id: string,
  unique_id: string,
  data: any,
  legacy_app?: any,
  menuItem?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `data/module/${module_name}/submodule/${submodule_name}/directory_contents_files?&user_id=${user_id}&legacy_app=${
    legacy_app || ''
  }&unique_id=${unique_id}&menu_item=${menuItem}`;
  return ServiceRequest.post(url, {payload: data}, cancelToken);
};

export const getFileVersionData = async (data: any): Promise<any> => {
  const url = `data/fileVersion_data`;
  return ServiceRequest.post(url, {payload: data});
};

export const getFileVersions = async (data: any): Promise<any> => {
  const url = `data/fileVersions`;
  return ServiceRequest.post(url, {payload: data});
};

export const getFileData = async (
  data: any,
  cancelToken: CancelTokenSource
): Promise<any> => {
  const url = `data/file`;
  return ServiceRequest.post(url, {payload: data}, cancelToken);
};
export const getFileZIPData = async (data: any): Promise<any> => {
  const url = `/data/file-ZipDownload`;
  return ServiceRequest.post(url, {payload: data, responseType: 'blob'});
};
export const getDicomStudiesData = async (
  data: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `dicom/studies`;
  return ServiceRequest.post(url, {payload: data}, cancelToken);
};

export const downloadAsPdf = async (data: any): Promise<any> => {
  const url = `data/file/download_as_pdf`;
  try {
    return ServiceRequest.post(url, {payload: data, responseType: 'blob'});
  } catch (error) {
    throw new Error('Error processing the file.');
  }
};

export const editPurgeAndLegalHold = async (data: any): Promise<any> => {
  const url = `/purge_legal_hold/actions`;
  return ServiceRequest.post(url, {payload: data});
};

export const getDocumentsTreeData = async (
  module_name: string,
  submodule_name: string,
  user_id: string,
  data: any,
  legacy_app?: any,
  unique_id?: string,
  menuItem?: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `data/module/${module_name}/submodule/${submodule_name}/tree-data?user_id=${user_id}&legacy_app=${
    legacy_app || ''
  }&unique_id=${unique_id}&menu_item=${menuItem}`;
  return ServiceRequest.post(url, {payload: data}, cancelToken);
};

export const getReportsFileData = async (data: any): Promise<any> => {
  const url = `/reports_data/file`;
  return ServiceRequest.downloadFile(url, {
    payload: data,
    responseType: 'blob'
  });
};
export const getReportsFileExportData = async (data: any): Promise<any> => {
  const url = `/export/download`;
  return ServiceRequest.downloadFile(url, {
    payload: data,
    responseType: 'blob'
  });
};

export const changeStatusForDownloadedFiles = async (
  data: any
): Promise<any> => {
  const url = `/change_status_reports/file`;
  return ServiceRequest.post(url, {payload: data});
};

export const generateReports = async (
  module_name: string,
  submodule_name: string,
  data: any
): Promise<any> => {
  const url = `module/${module_name}/submodule/${submodule_name}/generate_reports`;
  return ServiceRequest.post(url, {payload: data});
};

export const generateCustomReports = async (
  module_name: string,
  submodule_name: string,
  data: any
): Promise<any> => {
  const url = `module/${module_name}/submodule/${submodule_name}/generate_custom_reports`;
  return ServiceRequest.post(url, {payload: data});
};

export const getRoleList = async (
  searchQuery: string,
  audit_event_description: string,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/user-access/submodule/roles/roles-list?search_text=${searchQuery}&is_audit=${true}&audit_event_description=${audit_event_description}`;
  return ServiceRequest.get(url);
};

export const getAllPermissionsList = async (
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/permissions/all`;
  return ServiceRequest.get(url);
};
export const getAllPermissionsListSettings = async (
  application_name: string
): Promise<any> => {
  const url = `/settings/permissions/all`;
  return ServiceRequest.get(url);
};
export const getRoleAndPermissionsData = async (
  role_id: number,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/roles/${role_id}`;
  return ServiceRequest.get(url);
};

export const addNewRoleAndPermissions = async (
  data: any,
  application_name: string
): Promise<any> => {
  const url = `${application_name}/roles`;
  return ServiceRequest.post(url, {payload: data});
};

export const updateRoleAndPermissions = async (
  role_id: number,
  data: any,
  application_name: string
): Promise<any> => {
  const url = `${application_name}/roles/${role_id}`;
  return ServiceRequest.put(url, {payload: data});
};

export const deleteRoleAndPermissions = async (
  role_id: number | undefined,
  data: any
): Promise<any> => {
  const url = `/roles/${role_id}`;
  return ServiceRequest.delete(url, {payload: data});
};

export const getUserGroupList = async (
  searchQuery: string,
  audit_event_description: string,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/user-access/submodule/user-groups/user-groups-list?search_text=${searchQuery}&is_audit=${true}&audit_event_description=${audit_event_description}`;
  return ServiceRequest.get(url);
};

export const getUserGroupRolesData = async (
  user_group_id: number,
  application_name: string
): Promise<any> => {
  const url = `${application_name}/user-groups/${user_group_id}`;
  return ServiceRequest.get(url);
};
export const syncUserGroups = async (
  data: any,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/user-groups-sync/sync`;
  return ServiceRequest.get(url, {payload: data});
};
export const syncUsers = async (
  data: any,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/users-sync/sync`;
  return ServiceRequest.get(url, {payload: data});
};

export const getUserBasedOnGroupData = async (
  user_group_id: number
): Promise<any> => {
  const url = `/users/user_group/${user_group_id}`;
  return ServiceRequest.get(url);
};

export const addNewGroup = async (
  data: any,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/user-groups/new-group`;
  return ServiceRequest.post(url, {payload: data});
};

export const addNewADGroup = async (
  data: any,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/user-groups/new-AD-group`;
  return ServiceRequest.post(url, {payload: data});
};

export const updateUserGroupRolesData = async (
  user_group_id: number,
  data: any,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/user-groups/${user_group_id}`;
  return ServiceRequest.put(url, {payload: data});
};

export const validateDeleteGroup = async (
  group_id: number,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/validate/user-groups/${group_id}`;
  return ServiceRequest.get(url);
};

export const deleteGroup = async (
  group_id: number,
  data: any
): Promise<any> => {
  const url = `/user-groups/${group_id}`;
  return ServiceRequest.delete(url, {payload: data});
};

export const getAllUsers = async (
  data: any,
  application_name: any
): Promise<any> => {
  // eslint-disable-next-line max-len
  const url = `${application_name}/user-access/submodule/users/users-list`;
  return ServiceRequest.post(url, {payload: data});
};

export const getAllUsersSettings = async (
  data: any,
  application_name: any
): Promise<any> => {
  // eslint-disable-next-line max-len
  const url = `settings/user-access/submodule/users/users-list`;
  return ServiceRequest.post(url, {payload: data});
};
export const getEndPoints = async (iss: any, appendURL: any): Promise<any> => {
  const url = `${iss}${appendURL}`;
  return ServiceRequest.get(url);
};

export const generateAccessToken = async (
  url: any,
  data: any
): Promise<any> => {
  try {
    const response = await axios.post(url, data, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    });
    return response.data;
  } catch (err: any) {
    Services.genericErrorHandler(err);
  }
};

export const getEpicPatient = async (mrn: string): Promise<any> => {
  const url = `/epic/patient/${mrn}`;
  return ServiceRequest.get(url);
};

export const getAthenaPatient = async (mrn: string): Promise<any> => {
  const url = `/athena/patient/${mrn}`;
  return ServiceRequest.get(url);
};

export const signOutUser = async (data: any): Promise<any> => {
  const url = `/auth/logout`;
  return ServiceRequest.post(url, {payload: data});
};

export const adfsLogOutService = async (data: any): Promise<any> => {
  return await ServiceRequest.post('/auth/saml/logout', {payload: data});
};

export const getReferenceData = async (): Promise<any> => {
  const url = `/reference-data/all`;
  return ServiceRequest.get(url);
};

export const getWidgetsData = async (): Promise<any> => {
  const url = `/widgets/list/all`;
  return ServiceRequest.get(url);
};

export const postUIErrorLog = async (data: any): Promise<any> => {
  const url = `/user-access/ui-error-logs`;
  return ServiceRequest.post(url, {payload: data});
};

export const updateUserGroups = async (
  user_id: any,
  data: any,
  application_name: any
): Promise<any> => {
  const url = `${application_name}/user/user-groups/${user_id}`;
  return ServiceRequest.put(url, {payload: data});
};

export const getADGroupsList = async (
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/user/user-groups/AD-groups-list`;
  return ServiceRequest.get(url);
};

export const getUserPermissions = async (): Promise<any> => {
  const url = `/user/permissions/all`;
  return ServiceRequest.get(url);
};

export const getApplicationPods = async (): Promise<any> => {
  const url = `/uam/pods`;
  return ServiceRequest.get(url);
};
export const getAllUserGroups = async (): Promise<any> => {
  const url = `/uam/user-groups`;
  return ServiceRequest.get(url);
};
export const getAllUserGroupsByApplication = async (): Promise<any> => {
  const url = `/uam/user-groups/by-applications`;
  return ServiceRequest.get(url);
};
export const getUAMTabPermissions = async (): Promise<any> => {
  const url = `/uam/permissions`;
  return ServiceRequest.get(url);
};
export const getAllPodsUsers = async ( payload: any,): Promise<any> => {
  const url = `/uam/users`;
   return ServiceRequest.post(url, {payload: payload});
};

export const getUamUserdetails = async ( payload: any,): Promise<any> => {
  const url = `/uam/users/details`;
   return ServiceRequest.post(url, {payload: payload});
};
export const editUamUserdetails = async ( payload: any,): Promise<any> => {
  const url = `/uam/users/edit-details`;
   return ServiceRequest.post(url, {payload: payload});
};
export const deleteUamUserdetails = async ( payload: any,): Promise<any> => {
  const url = `/uam/users/delete`;
   return ServiceRequest.post(url, {payload: payload});
};

export const softDeleteUser = async (
  data: any,
  application_name: string
): Promise<any> => {
  const url = `/${application_name}/user/delete-user`;
  return ServiceRequest.put(url, {payload: data});
};

export const ToggleDepartment = async (
  data: any,
  application_name: string,
  type: any
): Promise<any> => {
  const url = `/${application_name}/toggle-department/${type}`;
  return ServiceRequest.put(url, {payload: data});
};

export const getIsBhOptions = async (module_name: string): Promise<any> => {
  const url = `/module/${module_name}/is-bh-options`;
  return ServiceRequest.get(url);
};

export const createAuditLog = async (
  module_name: string,
  data: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `module/${module_name}/new-audit-log`;
  return ServiceRequest.post(url, {payload: data, cancelToken});
};

// ----- RCM APIS
export const getRCMLegacyApps = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-legacy-apps';
  return ServiceRequest.post(url, {payload: data});
};

export const getBytepadUsers = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-bytepad-users';
  return ServiceRequest.post(url, {payload: data});
};

export const updateBatchDetails = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/update-batch-details';
  return ServiceRequest.put(url, {payload: data});
};

export const addBatchRemarks = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/add-batch-remarks';
  return ServiceRequest.post(url, {payload: data});
};

export const getBatchRemarks = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-batch-remarks';
  return ServiceRequest.post(url, {payload: data});
};

export const createNewBatch = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/create-new-batch';
  return ServiceRequest.post(url, {payload: data});
};

export const markBatchesReviewed = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/mark-batches-reviewed';
  return ServiceRequest.put(url, {payload: data});
};

export const getTransactionList = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-transaction-list';
  return ServiceRequest.post(url, {payload: data});
};

export const getInvoiceDetails = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-invoice-details';
  return ServiceRequest.post(url, {payload: data});
};

export const getServiceLines = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-service-lines';
  return ServiceRequest.post(url, {payload: data});
};

export const getInvoices = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-invoice';
  return ServiceRequest.post(url, {payload: data});
};

export const getTransactionListSummary = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-transaction-list-summary';
  return ServiceRequest.post(url, {payload: data});
};

export const getPayerMaster = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-payer-master';
  return ServiceRequest.post(url, {payload: data});
};

export const getCollectionAgencies = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-collection-agencies';
  return ServiceRequest.post(url, {payload: data});
};

export const getSelfPayFinancialClasses = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-self-pay-financial-class';
  return ServiceRequest.post(url, {payload: data});
};

export const getPayCodes = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-pay-codes';
  return ServiceRequest.post(url, {payload: data});
};

export const getAdjustmentCodes = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-adjustment-codes';
  return ServiceRequest.post(url, {payload: data});
};

export const getAgencyPayCodes = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-agency-pay-codes';
  return ServiceRequest.post(url, {payload: data});
};

export const getDenialReasonCodes = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-denial-reason-codes';
  return ServiceRequest.post(url, {payload: data});
};

export const getTransactionStatusCodes = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-transaction-status-codes';
  return ServiceRequest.post(url, {payload: data});
};

export const applyCollectionAgencyPayment = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/apply-collection-agency-payment';
  return ServiceRequest.put(url, {payload: data});
};

export const applyPatientPayment = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/apply-patient-payment';
  return ServiceRequest.put(url, {payload: data});
};

export const getBatchDetails = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-batch-details';
  return ServiceRequest.post(url, {payload: data});
};

export const postPayment = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/post-payment';
  return ServiceRequest.post(url, {payload: data});
};

export const postLineItemTransactions = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/post-line-item-transactions';
  return ServiceRequest.post(url, {payload: data});
};

export const postInvoiceTransactions = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/post-invoice-transactions';
  return ServiceRequest.post(url, {payload: data});
};

export const clearPaymentEntryTransactions = async (
  data: any
): Promise<any> => {
  const url = '/rcm/payment/cash-posting/clear-payment-entry-transactions';
  return ServiceRequest.put(url, {payload: data});
};

export const recalculatePaymentEntry = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/recalculate-service-lines';
  return ServiceRequest.post(url, {payload: data});
};

export const getBatchSummary = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/get-batch-summary';
  return ServiceRequest.post(url, {payload: data});
};

export const removeBatch = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/remove-batch';
  return ServiceRequest.put(url, {payload: data});
};

export const removeBatchDetail = async (data: any): Promise<any> => {
  const url = '/rcm/payment/cash-posting/remove-batch-detail';
  return ServiceRequest.put(url, {payload: data});
};

export const uploadERAFile = async (data: any): Promise<any> => {
  const url = '/rcm/payment/auto-post/upload-era-file';
  return ServiceRequest.postDoc(url, {payload: data});
};

export const getAcceptedTransactions = async (data: any): Promise<any> => {
  const url = '/rcm/payment/auto-post/get-era-transactions';
  return ServiceRequest.post(url, {payload: data});
};

export const runERA = async (data: any): Promise<any> => {
  const url = '/rcm/payment/auto-post/run-era-batch';
  return ServiceRequest.post(url, {payload: data});
};

export const getBatchListing = async (data: any): Promise<any> => {
  const url = '/rcm/payment/auto-post/get-era-batch-listing';
  return ServiceRequest.post(url, {payload: data});
};

export const exportBatchListing = async (data: any): Promise<any> => {
  const url = '/rcm/payment/auto-post/export-era-batch-listing';
  return ServiceRequest.downloadFile(url, {
    payload: data,
    responseType: 'blob'
  });
};

export const getAutoPostBatchLedgerSummary = async (
  data: any
): Promise<any> => {
  const url = '/rcm/payment/auto-post/get-ledger-summary';
  return ServiceRequest.post(url, {payload: data});
};

export const getManualPostBatches = async (data: any): Promise<any> => {
  const url = '/rcm/payment/manual-post/get-batches';
  return ServiceRequest.post(url, {payload: data});
};

export const getPaymentReconciliationReport = async (
  data: any
): Promise<any> => {
  const url = '/rcm/report/payment-reconciliation-report';
  return ServiceRequest.post(url, {payload: data});
};

export const exportPaymentReconciliationReport = async (
  data: any
): Promise<any> => {
  const url = '/rcm/report/export-payment-reconciliation-report';
  return ServiceRequest.downloadFile(url, {
    payload: data,
    responseType: 'blob'
  });
};
export const exportDashboardReport = async (data: any): Promise<any> => {
  const url = '/rcm/report/export-dashboard-report';
  return ServiceRequest.downloadFile(url, {
    payload: data,
    responseType: 'blob'
  });
};

export const fetchRCMDashboardData = async (
  data: any,
  dashboard_type: string,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/data/rcm_dashboard/${dashboard_type}`;
  return ServiceRequest.post(url, {payload: data, cancelToken});
};

export const getClaimPreviewPdf = async (
  data: any,
  type: any
): Promise<any> => {
  const url = `/rcm/${type}/preview`;
  return ServiceRequest.post(url, {payload: data});
};

export const getPrintedClaim = async (data: any, type: any): Promise<any> => {
  const url = `/rcm/${type}/get-printed-pdf`;
  return ServiceRequest.downloadFile(url, {
    payload: data,
    responseType: 'blob'
  });
};

export const getTextClaim = async (data: any, type: any): Promise<any> => {
  const url = `/rcm/${type}/get-text-pdf`;
  return ServiceRequest.downloadFile(url, {
    payload: data,
    responseType: 'blob'
  });
};
export const getStatementPdfPA = async (data: any): Promise<any> => {
  const url = `/rcm/statement/pa-download-as-pdf`;
  return ServiceRequest.post(url, {payload: data});
};
export const getStatementPdfMRN = async (data: any): Promise<any> => {
  const url = `/rcm/statement/mrn-download-as-pdf`;
 return ServiceRequest.post(url, {payload: data});
};

// ----- RCM APIS
